<template>
  <section class="partner">
    <div class="container partner__text">
      <!-- 메인문구 -->
      <div class="partner__text-main">
        <div>이미 많은 기업이{{ '\n' }} <span class="gradient">디포스트의 편리함</span>을</div>
        <div>경험하고 가치를{{ '\n' }} 인정합니다.</div>
      </div>

      <!-- 서브문구 -->
      <div class="partner__text-sub">80,000+명의 임직원이 디포스트와 {{ '\n' }} 함께하고 있습니다.</div>
    </div>

    <div class="flex flex-col desktop:gap-8 mobile:gap-[26px]">
      <div
        class="logo-lines"
        aria-label="파트너사 목록"
      >
        <div class="logo-lines__content">
          <div class="logo-lines__logo logo-lines-left flex">
            <div
              v-for="(imgUrl, index) in firstMarquees"
              class="w-[180px] h-[70px] pr-[14px]"
            >
              <img
                :src="imgUrl"
                :alt="`image-${index}`"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="logo-lines"
        aria-label="파트너사 목록"
      >
        <div class="logo-lines__content">
          <div class="logo-lines__logo logo-lines-right flex">
            <div
              v-for="imgUrl in secondMarquees"
              class="w-[180px] h-[70px] pr-[14px]"
            >
              <img
                :src="imgUrl"
                :alt="imgUrl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
const imagesFirstLine = import.meta.glob('@/assets/image/logoLineFirst/*.png', { eager: true });
const imagesSecondLine = import.meta.glob('@/assets/image/logoLineSecond/*.png', { eager: true });

const firstMarquees = computed(() => {
  const REPEAT = 20;
  let lists: any[] = [];
  const imageUrls = Object.values(imagesFirstLine).map((mod: any) => mod.default);
  for (let i = 0; i < REPEAT; i++) {
    lists = lists.concat(imageUrls);
  }
  return lists;
});

const secondMarquees = computed(() => {
  const REPEAT = 20;
  let lists: any[] = [];
  const imageUrls = Object.values(imagesSecondLine).map((mod: any) => mod.default);
  for (let i = 0; i < REPEAT; i++) {
    lists = lists.concat(imageUrls);
  }
  return lists;
});
</script>

<style lang="scss" scoped>
.partner {
  @apply text-center whitespace-pre-wrap flex flex-col;
  @apply desktop:whitespace-normal desktop:gap-28 mobile:gap-[60px];

  &__text {
    @apply flex flex-col gap-4;
    @apply desktop:gap-10;

    &-main {
      @apply text-3xl font-black leading-[1.4];
      @apply desktop:text-5xl desktop:leading-[1.5];
    }
    &-sub {
      @apply font-semibold text-black5;
      @apply desktop:text-xl;
    }
  }
}

.logo-lines {
  @apply overflow-hidden;

  &__content {
    @apply w-[120vh];
  }
  &__logo {
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-duration: 240s;
    float: left;
  }

  .logo-lines-left {
    animation-name: logo-lines-left;
  }

  .logo-lines-right {
    animation-name: logo-lines-right;
  }
}

.gradient {
  background-image: linear-gradient(60deg, #005bff, #b4d9f8);
  background-clip: text;
  color: transparent;
  padding: 4px 0;
}

@keyframes logo-lines-left {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@keyframes logo-lines-right {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}
</style>
